import { render, staticRenderFns } from "./RoleAccept.vue?vue&type=template&id=7d410e94&scoped=true"
import script from "./RoleAccept.vue?vue&type=script&lang=ts"
export * from "./RoleAccept.vue?vue&type=script&lang=ts"
import style0 from "./RoleAccept.vue?vue&type=style&index=0&id=7d410e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d410e94",
  null
  
)

export default component.exports